import React from "react";
import { StaticImage } from "gatsby-plugin-image";
import * as styles from "./upcoming-shows.module.css";

const upcomingShows = () => (
  <section id="upcoming-shows" className="section-wrapper">
    <h2 className="section-title">
      <a href="#upcoming-shows">Upcoming Shows</a>
    </h2>

    {/* TODO: Add upcoming show */}
    <div className={styles.upcomingShowsWrapper}>
      <StaticImage
        src="../../images/upcoming-shows/spacebass_tour.png"
        alt="Spacebass Tour Flyer"
        placeholder="blurred"
        className={styles.upcomingShowImageItem}
      />
    </div>
  </section>
);

export default upcomingShows;
